import { lazy } from 'react';

export const PlayerAlternativeAddressForm = lazy(
  () => import('./PlayerAlternativeAddressForm'),
);
